import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import LanguageSwitcher from '../components/LanguageSwitcher';
import T from '../components/T';
import FacebookLogin from '../facebook/LoginButton';
import FacebookProvider from '../facebook/FacebookProvider';
import forceRerenderParent from '../components/forceRerenderParent';
import FloatingHeader from '../components/FloatingHeader';

class Form extends React.Component {
  formState = FormState.create(this);
  state = {};

  constructor(props) {
    super(props);

    this.state = this.formState.injectModel(props.form);
  }

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork();
    context.set(name, value).validate();
    context.updateFormState();
  }

  onSocialLogin = (formData) => {
    const { onSubmit } = this.props;
    onSubmit(new CustomEvent(''), formData);
  }

  onSubmit = (e, ) => {
    const { onSubmit } = this.props;
    e.preventDefault();

    const model = this.formState.createUnitOfWork().createModel();
    if (model) {
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  }

  render() {
    const { onCancel, formDisabled, showLoginForm, serverErrors } = this.props;
    const errors = populateFormErrors(this.formState, serverErrors);

    const leftChild = (
      <span className="u-link text-icon" onClick={onCancel}>
        <i className="icon-arrow-back text-icon__icon" />
        <span className="text-icon__text">Naspäť</span>
      </span>
    );

    return (
      <section className="new-campaign">
        <div className="c-floating">
          <FloatingHeader leftChild={leftChild} rightChild={<LanguageSwitcher />} />

          <FormStateForm formState={this.formState} className="c-floating__body" onSubmit={this.onSubmit}>
            <fieldset disabled={formDisabled}>
              <h1 className="new-campaign__header">
                <T msg="register.form.title" />
              </h1>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="register.form.labels.firstName" />
                </span>

                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.firstName }
                )}>
                  <WiredInput
                    name="firstName"
                    className="c-input"
                    onChange={this.onInputChange}
                    autoFocus
                    validator={v => v
                      .required().msg('register.form.errors.firstName.required')}
                  />
                </span>
                <ValidationMessage msg={errors.firstName} />
              </label>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="register.form.labels.lastName" />
                </span>

                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.lastName }
                )}>
                  <WiredInput
                    name="lastName"
                    className="c-input"
                    onChange={this.onInputChange}
                    validator={v => v
                      .required().msg('register.form.errors.lastName.required')}
                  />
                </span>
                <ValidationMessage msg={errors.lastName} />
              </label>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="register.form.labels.email" />
                </span>

                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.email }
                )}>
                  <WiredInput
                    name="email"
                    type="email"
                    className="c-input"
                    onChange={this.onInputChange}
                    validator={v => v
                      .required().msg('register.form.errors.email.required')
                      .email().msg('register.form.errors.email.email')}
                  />
                </span>
                <ValidationMessage msg={errors.email} />
              </label>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="register.form.labels.password" />
                </span>

                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.password }
                )}>
                  <WiredInput
                    name="password"
                    type="password"
                    className="c-input"
                    onChange={this.onInputChange}
                    validator={v => v
                      .required().msg('register.form.errors.password.required')
                      .minLength(window.DRJM.config.minimalPasswordLength).msg('register.form.errors.password.minLength')}
                  />
                </span>
                <ValidationMessage msg={errors.password} />
              </label>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="register.form.labels.phone" />
                </span>

                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.phone }
                )}>
                  <WiredInput
                    name="phone"
                    className="c-input"
                    onChange={this.onInputChange}
                    validator={v => v
                      .required().msg('register.form.errors.phone.required')}
                  />
                </span>
                <ValidationMessage msg={errors.phone} />
              </label>

              <div className="expander" />

              <button type="submit" className="c-button c-button--primary new-campaign__button">
                <span className="c-button__content">
                  <span className="text-icon">
                    <span className="text-icon__text">Zaregistrujte sa</span>
                    <i className="icon-arrow-forward text-icon__icon" />
                  </span>
                </span>
              </button>

              <div className="expander l-no-desktop l-no-tablet" />

              <div className="new-campaign__social">
                <div>
                  <FacebookProvider>
                    <FacebookLogin redirectTo="/Campaign" from="register" onLogin={this.onSocialLogin} />
                  </FacebookProvider>
                </div>
              </div>
            </fieldset>

            <div className="expander l-no-phone l-no-tablet" />
          </FormStateForm>
        </div>

        <div className="expander" />

        <button
          type="button"
          className="c-button c-button--secondary new-campaign__login-redirect"
          onClick={showLoginForm}
        >
          <span className="c-button__content">Už mám konto a chcem sa prihlásiť</span>
        </button>

        <div className="expander" />
      </section>
    );
  }
}

export default forceRerenderParent(Form);



// WEBPACK FOOTER //
// ./app/Assets/js/features/register/Form.js